import React from 'react';
import { Notification } from 'new/entities/Notification';
import { useFlowInsightsNavigationButton } from 'new/elements/FlowInsightsNavigationButton/useFlowInsightsNavigationButtonProps';
import { ReactComponent as Insights } from 'new/elements/FlowInsightsNavigationButton/insights.svg';

import s from './FlowInsightsNavigationButton.module.scss';

export interface iProps {
  notification: Notification;
}

export function FlowInsightsNavigationButton(props: iProps) {
  const { notification = {} as Notification } = props;
  const { resource_type: type, resource_id: id } = notification;
  const { navigateToFlowInsights } = useFlowInsightsNavigationButton(id, type);

  if (notification.level !== 'ERROR') return null;

  return (
    <button
      role="button"
      className={s.button}
      aria-label="Flow Insights"
      onClick={navigateToFlowInsights}
      {...props}
    >
      <Insights />
      Flow Insights
    </button>
  );
}
